import $ from 'jquery';

function initValidateForm() {
    const $validateForm = $('.js-validate-email-form');
    if (!$validateForm.length) { return; }

    $validateForm.submit(function (e) {
        const $emailInputs = $(this).find('.js-validate-email');
        const $validateMsg = $(this).find('.js-validate-msg');

        // Start by clearing msg
        $validateMsg.empty();

        // Check the email input
        if (!validateEmail($emailInputs.val())) {
            $validateMsg.html('Please enter a valid email address');
            e.preventDefault();
            return false;
        }

        // Checking passed
        return true;
    });
}

function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

$(() => {
    initValidateForm();
});



// WEBPACK FOOTER //
// ./src/sections/newsletter-signup/s-newsletter-signup.js